import '../../assets/css/common/modal.css';
import { Modal } from 'react-bootstrap';

const ImageModal = ({ show, handleClose, imageUrl }) => {
    return (
        <Modal
            // CMP-1634
            // react-bootstrap では、OS のアニメーション設定が OFF の場合に、
            // アニメーションの終了検知が上手くできないバグがあり、
            // モーダルを閉じる処理のタイミングが悪いと画面が操作不能になってしまうため、
            // アニメーションを無効にしているので注意
            animation={false}
            show={show}
            onHide={handleClose}
            centered={true}
        >
            <Modal.Body>
                <img src={imageUrl} alt="Modal Content" style={{ width: '100%' }} />
            </Modal.Body>
        </Modal>
    );
};

export default ImageModal;
